<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <FCHistory :history="history" :title="h3" />
  </div>
</template>

<script>
import FCHistory from "@/components/patterns/FCHistory";
export default {
  components: {
    FCHistory
  },
  mounted() {
    const ref = this.$store.state.menu.history.ref;
    const index = this.$store.state.menu.menuItems.map(e => e.ref).indexOf(ref);
    this.$store.state.menu.activeSection = index;
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.history.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.history.nav;
    this.onScroll();
  },
  data() {
    return {
      h2: "History",
      h3: "Club Rise",
      history: [
        {
          label: "2015",
          items: [
            {
              image: "2015-founded.jpg",
              label: "FC CINCINNATI FOUNDED",
              date: "AUGUST 2015"
            },
            {
              image: "2015-firstplayer.jpg",
              label: "FRANCHISE’S FIRST PLAYER ANNOUNCEMENT",
              date: "DECEMBER 2015"
            }
          ]
        },
        {
          label: "2016",
          items: [
            {
              image: "2016-inaugural.jpg",
              label: "INAUGURAL USL HOME MATCH",
              date: "APRIL 2016"
            },
            {
              image: "2016-attendance.jpg",
              label: "OHIO SOCCER ATTENDANCE RECORD",
              date: "JULY 2016"
            }
          ]
        },
        {
          label: "2017",
          items: [
            {
              image: "2017-usopencup.jpg",
              label: "US OPEN CUP SEMI-FINAL",
              date: "AUGUST 2017"
            },
            {
              image: "2017-attendance.jpg",
              label: "USL PLAYOFF ATTENDANCE RECORD",
              date: "AUGUST 2017"
            },
            {
              image: "2017-mercyhealth.jpg",
              label:
                "FC CINCINNATI & MERCY HEALTH ANNOUNCE KIT SPONSORSHIP DEAL",
              date: "NOVEMBER 2017"
            }
          ]
        },
        {
          label: "2018",
          items: [
            {
              image: "2018-mlsexpansion.jpg",
              label: "MLS Expansion",
              date: "May 2018"
            },
            {
              image: "2018-attendance.jpg",
              label: "USL SINGLE-MATCH ATTENDANCE RECORD",
              date: "September 2018"
            },
            {
              image: "2018-trainingcenter.jpg",
              label:
                "Mercy Health adds naming rights for the team’s Milford, Ohio training center",
              date: "September 2018"
            },
            {
              image: "2018-groundbreakingtraining.jpg",
              label: "Groundbreaking of Mercy Health Training Center",
              date: "September 2018"
            },
            {
              image: "2018-champions.jpg",
              label: "USL REGULAR-SEASON CHAMPIONS",
              date: "October 2018"
            },
            {
              image: "2018-foundation.jpg",
              label: "Launch of FCC Foundation",
              date: "October 2018"
            },
            {
              image: "2018-groundbreakingstadium.png",
              label: "Groundbreaking of Stadium",
              date: "December 2018"
            }
          ]
        },
        {
          label: "2019",
          items: [
            {
              image: "2019-seattle.jpg",
              label: "FIRST MLS MATCH IN SEATTLE",
              date: "MARCH 2019"
            },
            {
              image: "2019-futsolcourts.jpg",
              label: "FCC OPENS FUTSOL COURTS",
              date: "MARCH 2019"
            },
            {
              image: "2019-homematch.jpg",
              label: "INAUGURAL MLS HOME MATCH",
              date: "MARCH 2019"
            }
          ]
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  background-image: url("~@/assets/backgrounds/bg-clubrise.jpg");
  background-size: cover;
  background-position: center;
}
</style>